import { motion } from "framer-motion";
import Image from "../../../elements/Image";
import Image01 from "../../../../assets/images/photo001.webp";
import Image02 from "../../../../assets/images/photo002.webp";
import Image03 from "../../../../assets/images/photo003.webp";
import Image04 from "../../../../assets/images/photo004.webp";
import Image05 from "../../../../assets/images/photo005.webp";
import Image06 from "../../../../assets/images/photo006.webp";
import Image07 from "../../../../assets/images/photo007.webp";
import Image08 from "../../../../assets/images/photo008.webp";
import Image09 from "../../../../assets/images/photo009.webp";
import Image10 from "../../../../assets/images/photo0010.webp";
import Image11 from "../../../../assets/images/photo0011.webp";
import Image12 from "../../../../assets/images/photo0012.webp";
import Image13 from "../../../../assets/images/photo0013.webp";
import Image14 from "../../../../assets/images/photo0014.webp";
import Image15 from "../../../../assets/images/photo0015.webp";
import Image16 from "../../../../assets/images/photo0016.webp";
import Image17 from "../../../../assets/images/photo0017.webp";
import Image18 from "../../../../assets/images/photo0018.webp";
import Image19 from "../../../../assets/images/photo0019.webp";
import Image20 from "../../../../assets/images/photo0020.webp";
import Image21 from "../../../../assets/images/photo0021.webp";
import Image22 from "../../../../assets/images/photo0022.webp";
import Image23 from "../../../../assets/images/photo0023.webp";
import Image24 from "../../../../assets/images/photo0024.webp";
import Image25 from "../../../../assets/images/photo0025.webp";
import Image26 from "../../../../assets/images/photo0026.webp";
import Image27 from "../../../../assets/images/photo0027.webp";
import Image28 from "../../../../assets/images/photo0028.webp";
import { classNames } from "../../../../helpers/classNames";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { postFrontDetails } from "../../../../services/postService";
import { lngDetect } from "../../../common/lngDetect";

const container = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { staggerChildren: 0.15, duration: 0.8, ease: "easeOut" },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const fadeScale = {
  hidden: { opacity: 0, scale: 0.9 },
  show: {
    opacity: 1,
    scale: 1,
    transition: { duration: 1.2, ease: "easeOut" },
  },
};

const HeroBanner = ({}) => {
  const { data: heroData, isLoading } = useQuery({
    queryKey: ["front-hero-section"],
    queryFn: async () => {
      const res = await postFrontDetails({
        slug: "hero-section",
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.data;
    },
  });

  const chunkArray = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };

  const newHeroData = {
    title: lngDetect(heroData?.content)?.title,
    subTitle: lngDetect(heroData?.content)?.subTitle,
    description: lngDetect(heroData?.content)?.excerpt,
    features:
      (heroData?.sections || [])?.map((item) => ({
        icon: item?.icon,
        text: item?.heading,
      })) || [],
    flimstrip: heroData?.mediaGallery
      ? chunkArray(
          heroData.mediaGallery.map((item) => item?.url),
          7
        ).map((chunk) => ({ images: chunk }))
      : [],
  };

  const appStoreData = [
    { name: "Google Play", link: "/", icon: "fa-brands fa-google-play" },
    { name: "Apple Store", link: "/", icon: "fa-brands fa-apple text-2xl" },
  ];

  // Skeleton filmstrip for loading state
  const skeletonFilmstrip = Array(4)
    .fill(null)
    .map((_, rowIndex) => ({
      images: Array(7).fill(null),
    }));

  return (
    <motion.section
      className="relative flex items-center w-full h-[700px] xls:min-h-screen pt-10 lg:pt-48 pb-10 lg:pb-24 z-0 overflow-hidden"
      initial="hidden"
      animate="show"
      variants={fadeScale}
    >
      <motion.div
        animate={{ opacity: [0.1, 0.2, 0.1], scale: [1, 1.2, 1] }}
        transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
        className="hidden lg:block absolute -top-[25vh] -left-[25vh] h-screen aspect-square bg-electric-violet/50 rounded-full blur-3xl z-[-1]"
      />

      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
        <motion.div className="flex" variants={container}>
          <div className="w-full max-w-2xl xl:max-w-3xl space-y-10 sm:pr-10">
            {isLoading ? (
              <div className="space-y-6 animate-pulse">
                {/* Subtitle Skeleton */}
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-gray-600"></div>
                  <div className="h-4 w-32 bg-gray-600 rounded"></div>
                </div>

                {/* Title Skeleton */}
                <div className="space-y-3">
                  <div className="h-10 sm:h-12 xl:h-16 w-full max-w-xl bg-gray-600 rounded"></div>
                  <div className="h-10 sm:h-12 xl:h-16 w-4/5 bg-gray-600 rounded"></div>
                </div>

                {/* Description Skeleton */}
                <div className="space-y-2 max-w-lg">
                  <div className="h-5 w-full bg-gray-700 rounded"></div>
                  <div className="h-5 w-full bg-gray-700 rounded"></div>
                  <div className="h-5 w-3/4 bg-gray-700 rounded"></div>
                </div>

                {/* Features Skeleton */}
                <div className="space-y-3">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full bg-gray-600 flex-shrink-0"></div>
                      <div className="h-4 w-48 bg-gray-700 rounded"></div>
                    </div>
                  ))}
                </div>

                {/* App Store Buttons Skeleton */}
                <div className="flex flex-wrap items-center gap-4">
                  {[1, 2].map((i) => (
                    <div
                      key={i}
                      className="w-40 h-12 rounded-full bg-gray-600"
                    ></div>
                  ))}
                </div>
              </div>
            ) : (
              <motion.div className="space-y-6" variants={container}>
                <motion.div
                  variants={item}
                  className="text-base font-semibold relative before:content-[''] before:w-2 before:aspect-square before:rounded-full before:bg-yellow-600 before:block flex items-center gap-2"
                >
                  {newHeroData?.subTitle}
                </motion.div>

                <motion.div className="space-y-6">
                  <motion.h1
                    variants={item}
                    className="text-3xl sm:text-4xl xl:text-6xl uppercase font-bold leading-tight"
                  >
                    {newHeroData?.title}
                  </motion.h1>

                  <motion.div
                    variants={item}
                    className="w-full max-w-lg xl:max-w-3xl space-y-4"
                  >
                    <div className="text-base xl:text-xl text-white leading-relaxed">
                      {newHeroData?.description}
                    </div>
                  </motion.div>
                </motion.div>

                {/* Features List */}
                <motion.div variants={item} className="space-y-3">
                  {newHeroData?.features.map((feature, index) => (
                    <motion.div
                      key={index}
                      variants={item}
                      className="flex items-center gap-3 text-sm xl:text-base text-white/90"
                    >
                      <div className="w-8 h-8 rounded-full bg-gradient-to-r from-yellow-400 to-orange-500 flex items-center justify-center flex-shrink-0">
                        <i
                          className={classNames(
                            feature.icon,
                            "text-electric-violet text-sm"
                          )}
                        ></i>
                      </div>
                      <span>{feature.text}</span>
                    </motion.div>
                  ))}
                </motion.div>

                {/* App Store Buttons */}
                {appStoreData?.length > 0 && (
                  <motion.div
                    variants={item}
                    className="flex flex-wrap items-center gap-4"
                  >
                    {appStoreData?.map((item, index) => (
                      <motion.a
                        key={index}
                        href={item?.link}
                        target="_blank"
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="px-6 h-12 rounded-full font-black text-lg transition-all flex items-center justify-center gap-3 shadow-xl bg-gradient-to-r from-yellow-400 to-orange-500 text-[#320051] hover:from-yellow-300 hover:to-orange-400"
                      >
                        <i className={classNames("fa-fw", item?.icon)}></i>
                        <span className="text-sm sm:text-base">
                          {item?.name}
                        </span>
                      </motion.a>
                    ))}
                  </motion.div>
                )}
              </motion.div>
            )}
          </div>
        </motion.div>
      </div>

      {/* Image Filmstrip */}
      <div className="absolute top-0 right-0 w-full lg:w-3/5 xls:w-1/2 h-full z-[-2] flex opacity-25 lg:opacity-100 overflow-hidden rounded-bl-7xl">
        {isLoading ? (
          // Skeleton Filmstrip
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex gap-2 xls:gap-4 rotate-3 lg:opacity-60">
            {skeletonFilmstrip.map((row, rowIndex) => (
              <div key={rowIndex} className="flex flex-col gap-2 xls:gap-4">
                {row.images.map((_, idx) => (
                  <div
                    className="w-36 sm:w-44 xlx:w-52 xl:w-60 2xl:w-72 aspect-[7/10] overflow-hidden flex-shrink-0 rounded-2xl bg-gray-700 animate-pulse"
                    key={idx}
                  />
                ))}
              </div>
            ))}
          </div>
        ) : (
          newHeroData?.flimstrip?.length > 0 && (
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex gap-2 xls:gap-4 rotate-3 lg:opacity-60">
              {newHeroData?.flimstrip?.map((row, rowIndex) => (
                <motion.div
                  key={rowIndex}
                  className="flex flex-col gap-2 xls:gap-4"
                  initial={{ opacity: 0.2, y: rowIndex % 2 === 0 ? -500 : 500 }}
                  animate={{ opacity: 1, y: rowIndex % 2 === 0 ? 250 : 0 }}
                  transition={{ duration: 3, ease: "easeInOut" }}
                >
                  {row.images?.map((img, idx) => (
                    <div
                      className="w-36 sm:w-44 xlx:w-52 xl:w-60 2xl:w-72 aspect-[7/10] overflow-hidden flex-shrink-0 rounded-2xl"
                      key={idx}
                    >
                      <Image
                        src={img}
                        alt={`signin-image-${idx}`}
                        effect="blur"
                        classes="object-cover"
                      />
                    </div>
                  ))}
                </motion.div>
              ))}
            </div>
          )
        )}

        <div className="absolute inset-0 overflow-hidden rounded-bl-7xl shadow-[inset_80px_-80px_80px_80px_#0b0b0f]" />
      </div>
    </motion.section>
  );
};

export default HeroBanner;
